import styled from 'styled-components'

export const DealsTargetBarContainer = styled.div<{ componentStyle?: string }>`
    ${(props) => props.componentStyle}
    border: var(--dashboard-default-border);
    border-radius: var(--dashboard-border-radius);
    display: flex;
    text-align: center;
    align-items: center;
    flex-direction: column;
    min-height: 120px;
    background-color: var(--dashboard-basic-background-color);
    cursor: default;
    label {
        width: 100%;
        font-size: 16px;
        line-height: 18px;
        text-align: left;
        font-weight: normal;
        padding: var(--dashboard-default-gap);
        color: var(--dashboard-main-color);
    }
    .container {
        padding: 0 1.5em 0 1.5em;
        width: 100%;
        .bar {
            background-image: linear-gradient(
                rgba(60, 60, 60, 1),
                rgba(15, 15, 15, 1)
            );
            width: 100%;
            height: 21px;
            border-radius: 12px;
            position: relative;
            display: flex;
            justify-content: left;
            align-items: center;
            border: solid 2px var(--dashboard-black-color);
            .progress {
                background-image: linear-gradient(
                    to right,
                    var(--dashboard-pro-color) 200px,
                    var(--dashboard-allstar-color) 200px
                );
                border-radius: 8px;
                height: 16px;
                width: var(--deals-target-bar-width);
                animation: progressAnimation 4s ease-in-out;
                padding: 0 5px;
                line-height: 16px;
            }
            figure {
                position: absolute;
                width: 50px;
                height: 50px;
                border-radius: 50%;
                border: solid 3.5px var(--dashboard-allstar-color);
                background-color: var(--dashboard-basic-background-color);
                display: flex;
                align-items: center;
                flex-direction: column;
                opacity: 0;
                animation: dropDown 0.3s ease-in-out;
                animation-fill-mode: forwards;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
                &::after {
                    content: attr(data-checkpoint);
                    position: absolute;
                    top: 48px;
                    font-weight: 600;
                    font-size: 0.9em;
                }
                &.achieved {
                    &::before {
                        content: '';
                        width: 50px;
                        height: 50px;
                        background-color: var(--dashboard-black-color);
                        position: absolute;
                        border-radius: 50%;
                        opacity: 0;
                        top: -4px;
                        animation: showUp 0.4s ease-out;
                        animation-fill-mode: forwards;
                        animation-delay: 2s;
                    }
                    &:last-child {
                        &::before {
                            animation-delay: 3.5s;
                        }
                        svg {
                            animation-delay: 3.5s;
                        }
                    }
                    svg {
                        animation: glow 0.8s ease-in;
                        animation-delay: 2s;
                        z-index: 1;
                    }
                }
                svg {
                    width: 90%;
                    color: var(--dashboard-allstar-color);
                }
                figcaption {
                    color: var(--dashboard-main-color);
                    font-size: 0.9em;
                    margin-top: 10px;
                }
                &:last-child {
                    border-color: var(--dashboard-mvp-color);
                    svg {
                        color: var(--dashboard-mvp-color);
                    }
                }
            }
        }
    }
    animation: fadeIn 0.8s ease-in-out;
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translate(0, -15px);
        }
        to {
            opacity: 1;
            transform: translate(0, 0);
        }
    }
    @keyframes dropDown {
        from {
            opacity: 0;
            transform: translate(0, -50px);
        }
        to {
            opacity: 1;
            transform: translate(0, 0);
        }
    }
    @keyframes glow {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.2);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes changeBg {
        from {
            background-color: var(--dashboard-basic-background-color);
        }
        to {
            background-color: var(--dashboard-black-color);
        }
    }
    @keyframes showUp {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    @keyframes progressAnimation {
        from {
            width: 0;
        }
        to {
            width: var(--deals-target-bar-width);
        }
    }
    &:hover {
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
`
